<template>
  <form class="card-modern space-y-6" @submit.prevent="handleSubmit">
    <div>
      <h2 class="text-2xl font-bold text-gray-900">Тексти сайту</h2>
      <p class="mt-2 text-sm text-gray-600">
        Ці тексти відображаються на головній сторінці над формою та у футері.
      </p>
    </div>

    <div class="space-y-4">
      <div>
        <label for="heroTitle" class="block text-sm font-medium text-gray-700 mb-2">
          Заголовок
        </label>
        <textarea
          id="heroTitle"
          v-model="draft.hero_title"
          rows="2"
          required
          class="admin-textarea"
          placeholder="Введіть заголовок"
        ></textarea>
      </div>

      <div>
        <label for="heroSubtitle" class="block text-sm font-medium text-gray-700 mb-2">
          Підзаголовок
        </label>
        <textarea
          id="heroSubtitle"
          v-model="draft.hero_subtitle"
          rows="2"
          required
          class="admin-textarea"
          placeholder="Введіть підзаголовок"
        ></textarea>
      </div>

      <div>
        <label for="footerCopyright" class="block text-sm font-medium text-gray-700 mb-2">
          Copyright у футері
        </label>
        <input
          id="footerCopyright"
          v-model="draft.footer_copyright"
          type="text"
          required
          class="admin-input"
          placeholder="Введіть copyright"
        />
      </div>
    </div>

    <div v-if="message" class="text-sm text-green-700 bg-green-50 border border-green-200 rounded-lg px-4 py-3">
      {{ message }}
    </div>

    <div v-if="siteSettingsStore.error" class="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-4 py-3">
      {{ siteSettingsStore.error }}
    </div>

    <div class="flex justify-end">
      <button
        type="submit"
        class="btn-hero"
        :disabled="siteSettingsStore.saving"
      >
        {{ siteSettingsStore.saving ? 'Збереження...' : 'Зберегти тексти' }}
      </button>
    </div>
  </form>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { defaultSiteSettings, useSiteSettingsStore, type SiteSettings } from '@/stores/siteSettings'

const siteSettingsStore = useSiteSettingsStore()
const message = ref('')
const draft = ref<SiteSettings>({ ...defaultSiteSettings })

watch(
  () => siteSettingsStore.settings,
  (settings) => {
    draft.value = { ...settings }
  },
  { immediate: true, deep: true }
)

const handleSubmit = async () => {
  message.value = ''
  const result = await siteSettingsStore.updateSiteSettings(draft.value)

  if (result.success) {
    message.value = 'Тексти успішно збережено'
  }
}
</script>
